import { render, staticRenderFns } from "./UploadCodKerryAcc.vue?vue&type=template&id=404d71a8&"
import script from "./UploadCodKerryAcc.vue?vue&type=script&lang=js&"
export * from "./UploadCodKerryAcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports